<template>
  <NavButton :btn-key="btnKey" @click="click" />
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'

import NavButton from '@/components/public/NavButtons/NavButton.vue'
import { NavButtonKeys } from '@/types'
import { useUserDetailsStore } from '@/store/public/userDetails'
import { useFeedbackStore } from '@/store/public/feedback'
import typedStore from '@/store/typedStore'

const components = {
  NavButton,
}

@Component({ components })
export default class NavBtnReset extends Vue {
  get btnKey() {
    return NavButtonKeys.RESET
  }

  click() {
    typedStore.public.display.activateInitialTab({ dataTabsOnly: false, primaryAppOnly: true })
    useFeedbackStore().reset()
    useUserDetailsStore().reset()
    typedStore.public.display.showSplashScreen()
  }
}
</script>
